<div class="lbl">
  <div class="lbl__head">
    <div>
      <span class="lbl__eyebrow">{{ data.reference ? '#' + data.reference : 'Belföld' }}<ng-container *ngIf="info?.environment === 'test'"> · TESZT</ng-container></span>
      <h2>{{ title }}</h2>
    </div>
    <button type="button" class="stk-icon-btn" (click)="cancel()" aria-label="Bezárás">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><line x1="6" y1="6" x2="18" y2="18"></line><line x1="18" y1="6" x2="6" y2="18"></line></svg>
    </button>
  </div>

  <div class="lbl__body">
    <div class="lbl__note" *ngIf="loading">Adatok betöltése…</div>

    <div class="lbl__alert lbl__alert--warn" *ngIf="info && !info.configured">
      A Foxpost még nincs beállítva. Beállítások → Foxpost: felhasználónév, jelszó, API kulcs.
    </div>

    <ng-container *ngIf="draft && info?.configured">
      <div class="lbl__alert lbl__alert--warn" *ngIf="info?.existingLabel?.trackingCode">
        Már van címke ({{ info?.existingLabel?.trackingCode }}).
        {{ info?.existingLabel?.provider === 'foxpost' ? 'Az új Foxpost címkénél a régi csomagot automatikusan töröljük.' : 'A régi küldeményt a saját rendszerében kell törölni, ha nem adod fel.' }}
      </div>
      <ul class="lbl__warnings" *ngIf="info?.warnings?.length">
        <li *ngFor="let w of info?.warnings">{{ w }}</li>
      </ul>

      <div class="fxp-modes" role="tablist">
        <button type="button" class="fxp-mode" [class.fxp-mode--on]="draft.mode === 'home'" (click)="setMode('home')">Házhozszállítás</button>
        <button type="button" class="fxp-mode" [class.fxp-mode--on]="draft.mode === 'apm'" (click)="setMode('apm')">Automata</button>
      </div>

      <section class="lbl__section">
        <div class="lbl__kicker">Címzett</div>
        <div class="lbl__grid">
          <label class="lbl__f lbl__f--wide"><span class="stk-label">Név</span><input class="stk-input" [(ngModel)]="draft.recipient.name"></label>
          <label class="lbl__f"><span class="stk-label">Telefon (+36…)</span><input class="stk-input" [class.lbl__bad]="!draft.recipient.phone" [(ngModel)]="draft.recipient.phone" placeholder="+36301234567"></label>
          <label class="lbl__f"><span class="stk-label">E-mail</span><input class="stk-input" [class.lbl__bad]="!draft.recipient.email" [(ngModel)]="draft.recipient.email"></label>
          <ng-container *ngIf="draft.mode === 'home'">
            <label class="lbl__f"><span class="stk-label">Irányítószám</span><input class="stk-input" maxlength="4" [(ngModel)]="draft.recipient.zip"></label>
            <label class="lbl__f"><span class="stk-label">Város</span><input class="stk-input" [(ngModel)]="draft.recipient.city"></label>
            <label class="lbl__f lbl__f--wide"><span class="stk-label">Utca, házszám</span><input class="stk-input" [(ngModel)]="draft.recipient.address"></label>
            <label class="lbl__f lbl__f--wide"><span class="stk-label">Megjegyzés a futárnak (nem kötelező)</span><input class="stk-input" maxlength="50" [(ngModel)]="draft.deliveryNote"></label>
          </ng-container>
        </div>
      </section>

      <section class="lbl__section" *ngIf="draft.mode === 'apm'">
        <div class="lbl__kicker">Automata</div>
        <div class="fxp-apm-picked" *ngIf="draft.apm">
          <strong>{{ draft.apm.name }}</strong>
          <span>{{ draft.apm.address }} · {{ draft.apm.id }}</span>
        </div>
        <label class="lbl__f"><span class="stk-label">{{ draft.apm ? 'Másik automata keresése' : 'Keresés (város, utca, üzlet, azonosító)' }}</span>
          <input class="stk-input" [ngModel]="apmQuery" (ngModelChange)="onApmQuery($event)" placeholder="pl. Kecskemét Tesco">
        </label>
        <div class="lbl__note" *ngIf="apmSearching">Keresés…</div>
        <div class="fxp-apms" *ngIf="apmResults.length">
          <button type="button" class="fxp-apm" *ngFor="let apm of apmResults" (click)="pickApm(apm)">
            <strong>{{ apm.name }}</strong>
            <span>{{ apm.address }} · {{ apm.id }}</span>
          </button>
        </div>
      </section>

      <section class="lbl__section">
        <div class="lbl__kicker">Csomag</div>
        <div class="lbl__grid">
          <label class="lbl__f"><span class="stk-label">Méret</span>
            <select class="stk-input" [(ngModel)]="draft.size">
              <option *ngFor="let s of info?.sizes" [value]="s">{{ sizeLabels[s] || s }}</option>
            </select>
          </label>
          <label class="lbl__f"><span class="stk-label">Utánvét (Ft)</span><input class="stk-input" type="number" min="0" step="1" [(ngModel)]="draft.cod" [disabled]="draft.replacement"></label>
          <label class="lbl__f lbl__f--wide"><span class="stk-label">Megjegyzés a címkén</span><input class="stk-input" maxlength="50" [(ngModel)]="draft.comment"></label>
        </div>
        <label class="lbl__save" *ngIf="draft.mode === 'home'">
          <input type="checkbox" [(ngModel)]="draft.fragile">
          <span>Törékeny</span>
        </label>
      </section>
    </ng-container>
  </div>

  <div class="lbl__alert lbl__alert--error" *ngIf="error">{{ error }}</div>

  <div class="lbl__actions">
    <button type="button" class="stk-btn stk-btn--ghost" (click)="cancel()" [disabled]="busy">Mégse</button>
    <button type="button" class="stk-btn stk-btn--dark lbl__confirm fxp-confirm" (click)="create()" [disabled]="!canCreate">
      {{ busy ? 'Készül…' : 'Foxpost címke létrehozása' }}
    </button>
  </div>
</div>
